<template>
  <span class="edit-label edit-field">
      <input type="text" class="edit-label-input" v-model="item.family" ref="family">
      <v-select :appendToBody="true" :options="list" v-model="item.order_id" label="oorder" index="order_id"
        :reduce="r => r.order_id" :clearable="false" style="min-width: 150px;">
        <template v-slot:selected-option="option">
          {{ `${option.oorder}` }}
        </template>
        <template v-slot:option="option">
          {{ `${option.oorder}` }}
        </template>
        <template v-slot:no-options="{ search, searching }">
          <template v-if="searching">
            {{`${ $t('message.noResultsFor') } `}}<em>{{ search }}</em>.
          </template>
        </template>
      </v-select>
      <ul class="acoes d-flex justify-content-end">
        <li><a @click="salve"><span class="salvar mt-1"></span></a></li>
        <li><a @click="cancel"><span class="cancelar mt-1"></span></a></li>
      </ul>
  </span>
</template>

<script>
export default {
  name: 'EditTaxonomyFamily',
  props: {
    family: {},
    list: Array
  },
  data: function () {
    return {
      item: {
        family_id: 0,
        family: ''
      }
    }
  },
  methods: {
    cancel: function () {
      this.$emit('cancelEdit')
    },
    salve: function () {
      this.$emit('salveEdit', this.item)
    }
  },
  mounted () {
    this.item = this.family
    this.$refs.family.focus()
  }
}
</script>
